import UserType from 'modules/common/types/UserType.enum';

export const BusinessVerificationTaskName = {
    BUSINESS_VERIFICATION_UPLOAD_S_CORP_CONFIRMATION_LETTER: 'business_verification_upload_scorp_confirmation_letter',
    BUSINESS_VERIFICATION_UPLOAD_ARTICLES_OF_ORGANIZATION_MIDDESK:
        'business_verification_upload_articles_of_organization_middesk',
    BUSINESS_VERIFICATION_UPLOAD_EIN: 'business_verification_upload_ein',
    BUSINESS_VERIFICATION_UPLOAD_ARTICLES_OF_ORGANIZATION: 'business_verification_upload_articles_of_organization',
    BUSINESS_VERIFICATION_COMPLETE: 'business_verification_complete',
    VERIFY_BUSINESS: 'verify_business',
} as const;

export const DOCUMENT_TYPES_TO_TASK_NAMES = {
    EIN_CONFIRMATION_DOCUMENT: BusinessVerificationTaskName.BUSINESS_VERIFICATION_UPLOAD_EIN,
    S_CORP_ACCEPTANCE_LETTER: BusinessVerificationTaskName.BUSINESS_VERIFICATION_UPLOAD_S_CORP_CONFIRMATION_LETTER,
    ARTICLES_OF_ORGANIZATION:
        BusinessVerificationTaskName.BUSINESS_VERIFICATION_UPLOAD_ARTICLES_OF_ORGANIZATION_MIDDESK,
} as const;

export const BUSINESS_VERIFICATIONS_REQUIRED_DOCUMENTS_BY_USER_TYPE = {
    [UserType.SCorp_SCorp]: ['EIN_CONFIRMATION_DOCUMENT', 'S_CORP_ACCEPTANCE_LETTER', 'ARTICLES_OF_ORGANIZATION'],
    [UserType.SCorp_CCorp]: ['EIN_CONFIRMATION_DOCUMENT', 'ARTICLES_OF_ORGANIZATION'],
    [UserType.LLC_LLC]: ['EIN_CONFIRMATION_DOCUMENT', 'ARTICLES_OF_ORGANIZATION'],
    [UserType.LLC_SCorp]: ['EIN_CONFIRMATION_DOCUMENT', 'ARTICLES_OF_ORGANIZATION'],
    [UserType.SoleProprietor_LLC]: ['EIN_CONFIRMATION_DOCUMENT', 'ARTICLES_OF_ORGANIZATION'],
    [UserType.SoleProprietor_SCorp]: ['EIN_CONFIRMATION_DOCUMENT', 'ARTICLES_OF_ORGANIZATION'],
} as const;

export const DOCUMENT_TYPE_INFO = {
    S_CORP_ACCEPTANCE_LETTER: {
        label: 'S Corp Confirmation Letter (Form CP261 or LTR 385C)',
        description:
            "An S Corp Acceptance Letter is an official IRS notice confirming a company's approval to be taxed as an S Corporation, including the effective date and company details.",
    },
    EIN_CONFIRMATION_DOCUMENT: {
        label: 'EIN Confirmation Letter (Form CP575 or 147C)',
        description:
            'Issued by the IRS to confirm the assignment of an Employer Identification Number (EIN) to a business.',
    },
    ARTICLES_OF_ORGANIZATION: {
        label: 'Articles of Organization',
        description:
            'Articles of Organization is a legal document that establishes an LLC with the appropriate state authority.',
    },
} as const;
